import Document from '../domain/models/Document';

export default class DocumentService {
  constructor(studentService) {
    this.studentService = studentService;
  }

  addDocument(studentId, data, user) {
    const student = this.studentService.getById(studentId);
    if (!student) return null;
    const doc = new Document(data);
    const updatedDocs = [doc.toJSON(), ...student.documents.map((d) => d.toJSON())];
    return this.studentService.update(
      studentId,
      { documents: updatedDocs, lastUpdated: new Date().toISOString() },
      user
    );
  }

  updateDocument(studentId, documentId, updates, user) {
    const student = this.studentService.getById(studentId);
    if (!student) return null;
    const documents = student.documents.map((doc) => (doc.toJSON ? doc.toJSON() : doc));
    const nextDocuments = documents.map((doc) => {
      if (doc.id !== documentId) return doc;
      const nextMetadata = { ...(doc.metadata || {}) };
      if (updates.metadata) {
        Object.assign(nextMetadata, updates.metadata);
      }
      return {
        ...doc,
        ...updates,
        metadata: nextMetadata,
        updatedAt: new Date().toISOString()
      };
    });
    return this.studentService.update(
      studentId,
      { documents: nextDocuments, lastUpdated: new Date().toISOString() },
      user
    );
  }

  archiveDocument(studentId, documentId, user) {
    return this.updateDocument(
      studentId,
      documentId,
      {
        archived: true,
        archivedAt: new Date().toISOString(),
        archivedBy: user?.name || 'System'
      },
      user
    );
  }

  restoreDocument(studentId, documentId, user) {
    return this.updateDocument(
      studentId,
      documentId,
      {
        archived: false,
        archivedAt: null,
        archivedBy: null
      },
      user
    );
  }

  deleteDocument(studentId, documentId, user) {
    const student = this.studentService.getById(studentId);
    if (!student) return null;
    const nextDocuments = student.documents
      .map((doc) => (doc.toJSON ? doc.toJSON() : doc))
      .filter((doc) => doc.id !== documentId);
    return this.studentService.update(
      studentId,
      { documents: nextDocuments, lastUpdated: new Date().toISOString() },
      user
    );
  }
}
